module.exports = __webpack_public_path__ + "img/icon-unactive-user.ccc9970e.svg";